import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { LISService } from '../+products/lis/lis.service';
import { ProductOrchestratorService } from '../+products/product-orchestrator.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { InterviewProductDataProviderService } from './abstract-interview-product-data-provider.service';


@Injectable()
export class InterviewLISDataProviderService extends InterviewProductDataProviderService {

    constructor(store: Store,
        lisService: LISService,
        productOrchestratorService: ProductOrchestratorService,
        appInsightsService: AppInsightsService
    ) {
        super(store, lisService, productOrchestratorService, appInsightsService);
    }
}
